import { cx } from '@emotion/css';
import { Col } from 'antd';
import { useSelector } from 'react-redux';
import { Order } from 'src/models';
import { BaseStyle, Spacing } from 'src/styles';
import { Maybe } from 'src/utils';

import { CurrencyField } from '../CurrencyField/CurrencyField';
import { MButton } from '../MButton/MButton';
import { MFormDateField } from '../MFormDateField/MFormDateField';
import { MFormTextField } from '../MFormTextField/MFormTextField';
import { MModalBody, MModalFooter, MModalTitle } from '../MModal/SinglePageModal';
import { MTypography } from '../MTypography/MTypography';
import { SubmissionResult } from '../SubmissionResult/SubmissionResult';

interface ChangeOrderSucceededStepProps {
  onClose: () => void;
}

export const ChangeOrderSucceededStep = ({ onClose }: ChangeOrderSucceededStepProps) => {
  const order: Maybe<Order> = useSelector((state: any) => state.orders.update.data);

  return (
    <>
      <MModalTitle>Security Order Changed</MModalTitle>
      <MModalBody>
        <Col span={24} className={cx(BaseStyle.level, Spacing.my12)}>
          <SubmissionResult
            type='success'
            message='Your security order was successfully changed.'
            testId={'change-order-succeeded'}
          />
        </Col>
        <Col span={24} className={cx(BaseStyle.level, Spacing.my24)} data-testid={'change-order-succeeded-symbol'}>
          <MTypography variant='h6' align='center'>
            {order?.symbol}
          </MTypography>
        </Col>
        <Col span={24}>
          <MFormTextField label='Order Type' value={order?.type?.label} testId='change-order-succeeded-order-type' />
        </Col>
        <Col span={24}>
          <MFormTextField label='Share Quantity' value={order?.quantity} testId='change-order-succeeded-quantity' />
        </Col>
        {order?.type?.isLimit || order?.type?.isStopLimit ? (
          <Col span={24}>
            <MFormTextField
              label='Limit Price'
              value={<CurrencyField value={order.limit} />}
              testId='change-order-succeeded-limit-price'
            />
          </Col>
        ) : null}
        {order?.type?.isStopMarket || order?.type?.isStopLimit ? (
          <Col span={24}>
            <MFormTextField
              label='Stop Price'
              value={<CurrencyField value={order.stop} />}
              testId='change-order-succeeded-stop-price'
            />
          </Col>
        ) : null}
        <Col span={24}>
          <MFormTextField
            label='Order Expiration'
            value={order?.duration?.label}
            testId='change-order-succeeded-order-expiration'
          />
        </Col>
        <Col span={24}>
          <MFormDateField label='Updated On' value={order?.updatedAt} testId='change-order-succeeded-date' />
        </Col>
      </MModalBody>
      <MModalFooter className={BaseStyle.levelRight}>
        <MButton onClick={onClose} testId='change-order-succeeded-close'>
          Close
        </MButton>
      </MModalFooter>
    </>
  );
};
